import { Box, Typography } from "@mui/material";
import React from "react";
import useForm from "../Common/FormComponent/useForm";
import CommunicationHub from "../../services/api/CommunicationHub";

const UploadImageWrapper = ({
  onUpload,
  UploadComponent,
  uploadComponentProps = {},
  url,
}) => {
  const form = useForm({
    callback_key: "",
    presign_url: "",
    download_url: "",
    file: null,
  });
  const { callback_key, presign_url, download_url, file } = form.values;

  const handleChange = async (file) => {
    //make api call
    const payload = {
      filename: file.name,
    };
    const { callback_key, upload_url, download_url } =
      await CommunicationHub.postImage(payload);
    form.setFields({
      callback_key,
      presign_url: upload_url,
      download_url,
      file,
    });
  };
  const handleVideoUpload = () => {
    onUpload && onUpload({ url: download_url, file });
    form.initForm();
  };
  return (
    <UploadComponent
      {...uploadComponentProps}
      handleImageChange={handleChange}
      state="Add"
      imageKey={"thumbnail"}
      uploadUrl={"/communication_hub/upload_image/ack"}
      callback_key={callback_key}
      imageUrl={url}
      presign_url={presign_url}
      keyName="callback_key"
      maxSize={2}
      handleImageUrlChange={handleVideoUpload}
    />
  );
};

export default UploadImageWrapper;
